import { useState } from 'react'
import { Check, Copy } from 'lucide-react'
import { useAuth } from '@/features/auth/hooks/useAuth'
import NoAccessState from '@/features/auth/components/NoAccessState'
import { BTN_SECONDARY } from '@/shared/components/ui/styles'

/** Signed in with Entra, but not an active user in Users & roles (403 NO_ACCESS on /api/me). */
export default function NoAccessPage() {
  const { user, logout } = useAuth()
  const [copied, setCopied] = useState(false)
  const upn = user?.email ?? ''

  const copy = () => {
    navigator.clipboard.writeText(upn).then(() => setCopied(true)).catch(() => {})
  }

  return (
    <div className="flex min-h-[100dvh] flex-col items-center justify-center bg-gray-50 px-4">
      <img src="/logo-hc_global_02.png" alt="HC Global" className="mb-4 h-8" />
      <NoAccessState
        title="You don't have access to the Billing Portal"
        description="Ask an Administrator to add you in Users & roles, quoting the account below."
      />
      {upn && (
        <div className="-mt-8 mb-6 flex items-center gap-2 rounded border border-gray-200 bg-white px-3 py-1.5">
          <span className="font-mono text-xs text-gray-700">{upn}</span>
          <button type="button" onClick={copy} aria-label="Copy account" className="text-gray-400 hover:text-primary">
            {copied ? <Check size={14} /> : <Copy size={14} />}
          </button>
        </div>
      )}
      <button type="button" onClick={logout} className={BTN_SECONDARY}>Sign out</button>
    </div>
  )
}
